import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { globalTheme } from "../../styles";

export const CarrierOptions = ({ options, selectedValue, onChange }) => {
  return (
    <RadioGroup value={selectedValue} onChange={onChange}>
      {options.map((option, index) => (
        <FormControlLabel
          key={index}
          value={option.value}
          control={
            <Radio
              sx={{
                color: `${globalTheme.primaryColor}`,
                "&.Mui-checked": {
                  color: `${globalTheme.primaryColor}`,
                },
              }}
            />
          }
          label={option.label}
        />
      ))}
    </RadioGroup>
  );
};
